export const CLOSE_SESSION = "CLOSE_SESSION";
export const SET_USER_DATA = "SET_USER_DATA";
